import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { from, lastValueFrom, Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ServerConfigPath, ServerConfigService } from '../services/server-config.service';
import { HttpErrorHandler } from '../../shared/services/error-handler.service';

export const CloudApiBaseUrlToken = '[CloudApiBaseUrlToken]';

@Injectable()
export class BaseInterceptor implements HttpInterceptor {
  private cloudApiUrl: string = '';
  
  constructor(private readonly serverConfigService: ServerConfigService, private readonly errorHandler: HttpErrorHandler) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.processRequest(request, next));
  }

  private async processRequest(request: HttpRequest<any>, next: HttpHandler): Promise<HttpEvent<any>> {
    const url = request.url.toLowerCase();
    const isServerConfigRequest = url.endsWith(ServerConfigPath.toLowerCase());

    // This interceptor handles Cloud Api request URL's (allowing for global request/response processing), and the initial call to get the cloud api server info/url
    if (!(isServerConfigRequest || url.startsWith(CloudApiBaseUrlToken.toLowerCase())))
      return lastValueFrom(next.handle(request));

    // If we don't yet have the cloud api url, go get it
    await this.setCloudApiUrl(isServerConfigRequest);

    let newHeaders = request.headers;

    newHeaders = newHeaders.set('Content-Type', 'application/json');
    newHeaders = newHeaders.set('Accept', 'application/json');

    const newRequest = request.clone({
      url: request.url.replace(CloudApiBaseUrlToken, this.cloudApiUrl),
      headers: newHeaders
    });

    return lastValueFrom(next.handle(newRequest)
      .pipe(
        catchError(err => this.handleError(err, newRequest)),
        tap((httpEvent: HttpEvent<any>) => {
          this.processResponse(httpEvent);
        })
      ));
  }

  private async setCloudApiUrl(isServerConfigRequest: boolean) {
    if (!isServerConfigRequest && this.cloudApiUrl === '') {
      const serverConfig = await lastValueFrom(this.serverConfigService.get()); 

      this.cloudApiUrl = serverConfig.cloudAPIUrl;
    }
  }

  private processResponse(httpEvent: HttpEvent<any>) {
    if (httpEvent.type === 0) // Skip request
      return;
    
    if (httpEvent instanceof HttpResponse) {
      // console.log(`x-accela-traceid: ${httpEvent.headers.get('x-accela-traceid')}`);
    }
  }

  private handleError(error: HttpErrorResponse, request: HttpRequest<any>) {
    // TODO: Logging...
    // Data Dog Logging here or in HttpErrorHandler maybe...
    // Should probably create separate logging service we call into

    // TODO: Error handling...
    // We can handle the error here, then pass it through to the error handler service, only handle it here or pass it straight on to the error handler service
    // Depending on the type of error we may not have a trace id (or response for that matter...?)
    // console.log(`Error - BaseInterceptor... x-accela-traceid: ${error.headers.get('x-accela-traceid')}`);

    return this.errorHandler.handleError(error);
  }
}
